<template>
<basepage title="Genel Amaçlı Rapor" :status="status" :menuitems="menuItems" v-on:menuclick="menuClick">
  <template slot="toolbar">
    <v-text-field v-model="aranacak" flat="" solo-inverted="" hide-details :label="this.$t('Search')" append-icon="search"></v-text-field>
    <v-btn :disabled="status.loading" flat @click="kayitgetir()">Ara</v-btn>
  </template>

  <v-layout>
    <v-text-field hide-details :label="$t('Starting-Date')" type="date" v-model="prm.BaslangicTarih"></v-text-field>
    <v-text-field hide-details :label="$t('Finishing-Date')" type="date" v-model="prm.BitisTarih"></v-text-field>
  </v-layout>

  <template>
    <v-data-table :headers="parseDesign()" :items="desserts" class="elevation-1">
      <template v-slot:items="props">
        <td v-for="tableheader in parseDesign()" :key="tableheader.id">
          {{props.item[tableheader.value] | generalFormat }}
        </td>

      </template>
    </v-data-table>
    <raporsablon v-show="true" ref="raporsablon" v-model="sablon" dizayngrupadi="GenelAmacliCari" objectname="Models.GenelAmacliCariClass"></raporsablon>

  </template>

</basepage>
</template>

<script>
import basepage from "@/components/app/coper/comp/basepage.vue";
import tool from "../coper/tools";
import raporsablon from "@/components/app/coper/comp/raporsablon.vue";

export default {
  components: {
    basepage,
    raporsablon,
  },

  data() {
    return {

      prm: {
        SirketKodu: 1,
        BaslangicTarih : tool.Now_yyyy_MM_dd(),
        BitisTarih : tool.Now_yyyy_MM_dd(),
      },

      sablon: {
        design: []
      },
      desserts: [],
      status: tool.NewSatatus(),
      aranacak: "",
      menuItems: [{
          title: 'Excel'
        },
        {
          title: 'Menu Item 2...'
        },
      ],
    };
  },
  filters: {
    generalFormat: function (t) {

      var parsedDate = Date.parse(t);
      if (t!="" && isNaN(t) && !isNaN(parsedDate)) {

        if ((new Date(t)).getFullYear()>1890){
          return tool.Date_yyyy_MM_dd(t);
        }else{
          return "";
        }


      }

      return (t);
    },
  },
  methods: {

    isValidDate(date) {
      return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
    },

    parseDesign() {
      if (this.sablon.design.length > 0) {

        var temp = JSON.parse(this.sablon.design);
        var r = [];
        var i;
        for (i = 0; i < temp.length; i++) {
          if (temp[i].selected) {
            r.push(temp[i]);
          }
        }
        return r;

      } else {
        return []
      }
    },

    menuClick(index) {
      if (index == 0) {
        this.excell();
      } else if (index == 1) {

      }
    },

    excell() {
      this.$refs.raporsablon.Excel(this.prm);
    },

    kayitgetir() {
      this.$refs.raporsablon.Report(this.prm).then(
        confirm => {
          this.desserts = confirm;
        },
        confirm => {
          this.desserts = [];
        }
      );
    }
  },
  beforeMount: beforeMount,
};

function beforeMount() {

}
</script>
